var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportOptionDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Messages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,1 C2.790861,1 1,2.790861 1,5 L1,16 C1,18.209139 2.790861,20 5,20 L16.5,20 C18.709139,20 20.5,18.209139 20.5,16 L20.5,5 C20.5,2.790861 18.709139,1 16.5,1 L5,1 Z M5,0 L16.5,0 C19.2614237,-4.4408921e-16 21.5,2.23857625 21.5,5 L21.5,16 C21.5,18.7614237 19.2614237,21 16.5,21 L5,21 C2.23857625,21 4.4408921e-16,18.7614237 0,16 L8.8817842e-16,5 C4.4408921e-16,2.23857625 2.23857625,4.4408921e-16 5,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02474175,0 C1.37699672,0 1.92139078,0.444405594 1.92139078,0.793581419 L1.60115898,8.09453047 C1.60115898,8.44370629 1.31295037,8.7293956 0.960695389,8.7293956 C0.608440413,8.7293956 0.320231796,8.44370629 0.320231796,8.09453047 L0.160115898,0.825324675 C0.160115898,0.476148851 0.704509952,0 1.02474175,0 Z M0.960695389,10.3165584 C1.50508944,10.3165584 1.92139078,10.7292208 1.92139078,11.2688561 C1.92139078,11.8084915 1.50508944,12.2211538 0.960695389,12.2211538 C0.416301335,12.2211538 0,11.8084915 0,11.2688561 C0,10.7292208 0.416301335,10.3165584 0.960695389,10.3165584 Z M0.960695389,11.5862887 C1.15283447,11.5862887 1.28092719,11.4593157 1.28092719,11.2688561 C1.28092719,11.0783966 1.15283447,10.9514236 0.960695389,10.9514236 C0.768556311,10.9514236 0.640463593,11.0783966 0.640463593,11.2688561 C0.640463593,11.4593157 0.768556311,11.5862887 0.960695389,11.5862887 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-5-Dropdown",
    transform: "translate(-762.000000, -385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown-menu",
    transform: "translate(746.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interaction-field-Copy-6",
    transform: "translate(15.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interaction-field"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Messages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey-copy",
    transform: "translate(1.500000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#646464",
    id: "colour/dark-grey"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.500000, -2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    transform: "translate(11.500000, 6.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.500000, -6.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportOptionDesktop);
export default __webpack_public_path__ + "static/media/reportOptionDesktop.0a12d0ba919e0ce0af8d2ed3381d31f9.svg";
export { ForwardRef as ReactComponent };